export const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";
//# sourceMappingURL=is-svg-tag.js.map